import { TimeOffCategoryPolicySchema } from "@/pages/settings/time-off/policy/TimeOffCategoryPolicyEdit.tsx";
import { ApiTimeOffPolicyTerminationAccrualType } from "@/types/time-off/time-off-policy.types.ts";
import { Box, Radio, Stack, Title } from "@skailer-com/uikit";
import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface TimeOffPolicyTerminationAccrualProps {
  formHook: UseFormReturn<TimeOffCategoryPolicySchema>;
}

export function TimeOffPolicyTerminationAccrual({
  formHook,
}: TimeOffPolicyTerminationAccrualProps) {
  const { t } = useTranslation();
  const { control } = formHook;

  return (
    <Stack>
      <Title
        header={t("time_off:termination_accrual_type_title")}
        caption={t("time_off:termination_accrual_type_description")}
        size={"xs"}
        paddingBottom
      />
      <Box variant={"border"}>
        <Controller
          render={({ field: { value, onChange } }) => (
            <>
              <Radio
                value={ApiTimeOffPolicyTerminationAccrualType.proportional_accrual}
                checked={value == ApiTimeOffPolicyTerminationAccrualType.proportional_accrual}
                onChange={() => {
                  onChange(ApiTimeOffPolicyTerminationAccrualType.proportional_accrual);
                }}
                title={t("time_off:termination_accrual_type_proportional_title")}
                caption={t("time_off:termination_accrual_type_proportional_caption")}
              />
              <Radio
                value={ApiTimeOffPolicyTerminationAccrualType.no_partial_accrual}
                checked={value == ApiTimeOffPolicyTerminationAccrualType.no_partial_accrual}
                onChange={() => {
                  onChange(ApiTimeOffPolicyTerminationAccrualType.no_partial_accrual);
                }}
                title={t("time_off:termination_accrual_type_no_partial_title")}
                caption={t("time_off:termination_accrual_type_no_partial_caption")}
              />
            </>
          )}
          control={control}
          name={"termination_accrual_type"}
        />
      </Box>
    </Stack>
  );
}
